import React, { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import AccountSettingsModal from './AccountSettingsModal';
import './ProfileMenu.css';

export default function ProfileMenu() {
  const navigate = useNavigate();
  const { logout, isAuthenticated, user } = useAuth();
  const [isOpen, setIsOpen] = useState(false);
  const [showSettings, setShowSettings] = useState(false);
  const menuRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen]);

  if (!isAuthenticated) {
    return null;
  }

  const handleLogout = () => {
    if (window.confirm('Are you sure you want to logout?')) {
      logout();
    }
  };

  return (
    <div className="profile-menu-container" ref={menuRef}>
      <button 
        className="profile-menu-trigger"
        onClick={() => setIsOpen(!isOpen)}
        aria-label="Profile menu"
      >
        👤
      </button>
      
      {isOpen && (
        <div className="profile-menu-dropdown">
          <div className="profile-menu-header">
            <div className="profile-icon">👤</div>
            <div className="profile-info">
              <div className="profile-name">{user?.name || 'User'}</div>
              <div className="profile-email">{user?.email || 'Manage your account'}</div>
            </div>
          </div>
          
          <div className="profile-menu-divider"></div>
          
          <button 
            className="profile-menu-item"
            onClick={() => {
              setShowSettings(true);
              setIsOpen(false);
            }}
          >
            <span className="menu-icon">⚙️</span>
            <span>Manage Account</span>
          </button>
          
          <button 
            className="profile-menu-item"
            onClick={() => {
              navigate('/orders');
              setIsOpen(false);
            }}
          >
            <span className="menu-icon">📦</span>
            <span>Order History</span>
          </button>
          
          <button 
            className="profile-menu-item"
            onClick={() => {
              navigate('/addresses');
              setIsOpen(false);
            }}
          >
            <span className="menu-icon">📍</span>
            <span>Address Book</span>
          </button>
          
          <div className="profile-menu-divider"></div>
          
          <button 
            className="profile-menu-item logout"
            onClick={handleLogout}
          >
            <span className="menu-icon">🚪</span>
            <span>Logout</span>
          </button>
        </div>
      )}

      {showSettings && (
        <AccountSettingsModal
          isOpen={showSettings}
          onClose={() => setShowSettings(false)}
        />
      )}
    </div>
  );
}

